module.exports = __webpack_public_path__ + "static/media/hkd-5000.07f0c564.png";